<template>
  <div class="dialog-container" v-show="visible">
    <div class="dialog-mask" @click="handleClose"></div>
    <div class="custom-dialog" style="top: 10vh;">
      <div class="dialog-close" @click="handleClose">×</div>
      <div class="dialog-body replay-dialog-body">
        <div class="dialog-content" style="background-color: #ffffff; padding: 12px;">
          <h3 class="dialog-custom-title">赛事复盘
            <el-button type="text" class="download-btn" icon="el-icon-download" @click="handleDownload"></el-button>
          </h3>
          <div class="replay-view">
            <!-- 赛事信息 -->
            <div class="header-section">
              <!-- 订正/AK印章 -->
              <div v-if="stampType" class="mobile-replay-stamp">
                <div class="stamp-content" :class="{ 'ak-stamp': stampType === 'AK' }">
                  {{ stampType }}
                </div>
              </div>
              
              <div class="game-info">
                <div class="game-name">{{ gameInfo && gameInfo.game_name || '未命名赛事' }}</div>
                <div class="game-tags">
                  <span class="game-tag" v-if="gameInfo && gameInfo.game_level">{{ gameInfo.game_level }}</span>
                  <span class="game-tag" v-if="gameInfo && gameInfo.game_type">{{ gameInfo.game_type }}</span>
                </div>
              </div>
              <div class="score-rank-info">
                <div class="info-item">
                  <span class="label">得分：</span>
                  <span class="highlight">{{ gameInfo && gameInfo.total_score || 0 }}</span>
                  <span class="suffix">/{{ totalMaxScore }}</span>
                </div>
                <div class="info-item" v-if="gameInfo && gameInfo.rank && gameInfo.parameter_number">
                  <span class="label">排名：</span>
                  <span class="highlight">{{ gameInfo.rank }}</span>
                  <span class="suffix">/{{ gameInfo.parameter_number }}</span>
                </div>
              </div>
            </div>

            <!-- 全局复盘内容 -->
            <div class="global-replay" v-if="replayData && replayData.global_replay">
              <div class="section-title">
                <i class="el-icon-document"></i>
                整体复盘
              </div>
              <div class="replay-content" v-if="replayData && replayData.global_replay && replayData.global_replay.trim().length > 0">
                <mavon-editor 
                  :value="replayData.global_replay"
                  :subfield="false"
                  :defaultOpen="'preview'"
                  :toolbarsFlag="false"
                  :editable="false"
                  :boxShadow="false"
                  :navigation="false"
                  :tabSize="0"
                  :scrollStyle="false"
                  :ishljs="false"
                  previewBackground="transparent"
                  class="md-editor compact-editor"
                  style="border: none !important; margin: 0 !important; padding: 0 !important;"
                />
              </div>
            </div>

            <!-- 题目列表 -->
            <div class="questions-list" v-if="replayData && replayData.questions && replayData.questions.length > 0">
              <div class="section-title">
                <i class="el-icon-notebook-2"></i>
                题目复盘
              </div>
              <div class="question-items">
                <div v-for="question in replayData.questions" 
                     :key="question.question_code" 
                     class="question-card">
                  <div class="question-header">
                    <span class="question-seq" :style="getQuestionLevelStyle(question.question_level)">{{ question.question_seq }}</span>
                    <span class="question-name">{{ question.question_name }}</span>
                    <div class="question-scores" style="margin-left: 5px;">
                      <span class="score-label">得分：</span>
                      <span :style="{color: getScoreColor(question.question_score)}">{{ question.question_score }}</span>
                      <span class="separator">/</span>
                      <span :style="{color: getScoreColor(question.question_score_fix)}">{{ question.question_score_fix }}</span>
                    </div>
                  </div>
                  
                  <!-- 第一行：符合预期/补充知识点 -->
                  <div class="question-status">
                    <!-- 符合预期 -->
                    <span class="status-tag success" v-if="question.is_expect === '是'">
                      <i class="el-icon-check"></i> 符合预期
                    </span>
                    <span class="status-tag danger" v-else-if="question.is_expect === '否'">
                      <i class="el-icon-close"></i> 不符合预期
                    </span>
                    
                    <!-- 补充知识点 -->
                    <span class="status-tag warning" v-if="question.is_plan === '是'">
                      <i class="el-icon-warning"></i> 需要补充知识点
                      <span v-if="question.plan_name" class="plan-name">{{ question.plan_name }}</span>
                    </span>
                  </div>
                  
                  <!-- 第二行：错误类型 -->
                  <div class="question-errors" v-if="question.error_codes && question.error_codes.length > 0">
                    <el-tag
                      v-for="errorCode in question.error_codes"
                      :key="errorCode"
                      :style="getErrorOutlineStyle(errorCode)"
                      size="mini"
                      class="question-error-tag"
                      style="background-color: transparent !important;"
                    >
                      <i class="el-icon-warning" style="margin-right: 0px;"></i>
                      {{ getErrorName(errorCode) }}
                    </el-tag>
                  </div>
                  
                  <!-- 第三行：标签 -->
                  <div class="question-tags" v-if="question.tags && question.tags.length > 0">
                    <el-tag
                      v-for="tag in question.tags"
                      :key="tag.tag_code"
                      size="mini"
                      :class="getTagColorClass(tag.tag_code)"
                      class="question-tag"
                    >{{ tag.tag_name }}</el-tag>
                  </div>

                  <div class="replay-content" v-if="question.replay_info && question.replay_info.trim().length > 0">
                    <mavon-editor 
                      :value="question.replay_info"
                      :subfield="false"
                      :defaultOpen="'preview'"
                      :toolbarsFlag="false"
                      :editable="false"
                      :boxShadow="false"
                      :navigation="false"
                      :tabSize="0"
                      :scrollStyle="false"
                      :ishljs="false"
                      previewBackground="transparent"
                      class="md-editor compact-editor"
                      style="border: none !important; margin: 0 !important; padding: 0 !important;"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="empty-content" v-if="(!replayData || !replayData.global_replay) && (!replayData || !replayData.questions || replayData.questions.length === 0)">
              暂无复盘内容
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGameReplay } from '@/api/game'
import { getErrorCodes } from '@/api/error'
import { mavonEditor } from 'mavon-editor'
import { QUESTION_LEVELS, getQuestionLevelStyle } from '@/constants/questionLevel'
import { getErrorTagInlineStyle, getErrorOutlineStyle } from '@/constants/errorTypes'
import html2canvas from 'html2canvas'
import 'mavon-editor/dist/css/index.css'

export default {
  name: 'GameReplayMobileView',
  components: {
    mavonEditor
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    gameInfo: {
      type: [Object, null],
      default: () => ({})
    }
  },
  data() {
    return {
      replayData: {
        global_replay: '',
        questions: []
      },
      allErrors: [], // 错误类型列表
      loading: false
    }
  },

  created() {
    // 在组件创建时确保它被正确初始化，防止在生产环境中被优化掉
    console.log('GameReplayMobileView组件已创建，确保在生产环境中正常加载');
    // 如果有游戏信息，预加载复盘数据
    if (this.hasValidGameInfo && this.gameInfo.game_code) {
      this.fetchErrorCodes();
      this.fetchReplayData(this.gameInfo.game_code);
    }
  },

  computed: {
    totalMaxScore() {
      return this.replayData && this.replayData.questions ? this.replayData.questions.length * 100 : 0;
    },
    // 计算总订正分数
    totalScoreFix() {
      if (!this.replayData || !this.replayData.questions) return 0
      return this.replayData.questions.reduce((sum, q) => sum + (q.question_score_fix || 0), 0)
    },
    // 判断是否显示印章以及印章类型
    stampType() {
      // AK：原始分数 = 满分
      if (this.gameInfo && this.gameInfo.total_score === this.totalMaxScore && this.totalMaxScore > 0) {
        return 'AK'
      }
      // 订正：订正分数 = 满分 且 原始分数 < 满分
      if (this.totalScoreFix === this.totalMaxScore && this.totalMaxScore > 0 && 
          this.gameInfo && this.gameInfo.total_score < this.totalMaxScore) {
        return '订'
      }
      return null
    },
    // 添加安全访问辅助计算属性
    gameName() {
      return this.gameInfo && this.gameInfo.game_name || '未命名赛事';
    },
    hasValidGameInfo() {
      return this.gameInfo && typeof this.gameInfo === 'object' && Object.keys(this.gameInfo).length > 0;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.hasValidGameInfo && this.gameInfo.game_code) {
          this.fetchErrorCodes();
          this.fetchReplayData(this.gameInfo.game_code);
        }
      }
    },
    // 添加对gameInfo的监听
    'gameInfo.game_code': {
      handler(newVal) {
        if (newVal && this.visible) {
          this.fetchErrorCodes();
          this.fetchReplayData(newVal);
        }
      }
    }
  },
  methods: {
    getErrorTagInlineStyle,
    getErrorOutlineStyle,
    async fetchReplayData(game_code) {
      if (!game_code && this.gameInfo && this.gameInfo.game_code) {
        game_code = this.gameInfo.game_code;
      }
      
      if (!game_code) {
        console.error('获取复盘数据失败: 没有提供game_code或game_code无效');
        return;
      }
      
      this.loading = true;
      try {
        console.log('正在获取复盘数据，game_code:', game_code);
        const response = await getGameReplay(game_code);
        
        if (response.code === 200) {
          const data = response.data;
          if (data && (data.global_replay || (data.questions && data.questions.length > 0))) {
            this.replayData = data;
            // 在控制台打印，确认在生产环境中数据正常加载
            console.log('复盘数据加载成功:', data);
          } else {
            this.replayData = {
              global_replay: '',
              questions: []
            };
          }
        }
      } catch (error) {
        console.error('获取复盘数据失败:', error);
        this.$message.error('获取复盘数据失败');
        this.replayData = {
          global_replay: '',
          questions: []
        };
      } finally {
        this.loading = false;
      }
    },
    async fetchErrorCodes() {
      try {
        const res = await getErrorCodes();
        if (res.code === 200) {
          this.allErrors = res.data || [];
        }
      } catch (error) {
        console.error('获取错误类型列表失败:', error);
      }
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    async handleDownload() {
      try {
        const element = this.$el.querySelector('.replay-view')
        if (!element) {
          this.$message.error('未找到需要导出的内容')
          return
        }

        const wrappers = element.querySelectorAll('.v-note-wrapper')
        wrappers.forEach(wrapper => {
          const notePanel = wrapper.querySelector('.v-note-panel')
          const showContent = wrapper.querySelector('.v-note-show-content, .v-note-show, .v-show-content')
          if (notePanel) {
            notePanel.style.height = 'auto'
            notePanel.style.maxHeight = 'none'
          }
          if (showContent) {
            showContent.style.overflow = 'visible'
            showContent.style.height = 'auto'
            showContent.style.maxHeight = 'none'
          }
          wrapper.style.height = 'auto'
          wrapper.style.maxHeight = 'none'
        })

        await new Promise(resolve => setTimeout(resolve, 150))

        // 根据设备像素比自适应提升清晰度，最高提升至 3 倍
        const dpr = window.devicePixelRatio || 1
        const scaleForQuality = Math.min(3, dpr * 1.5)

        const canvas = await html2canvas(element, {
          useCORS: true,
          scale: scaleForQuality,
          scrollY: 0,
          height: element.scrollHeight,
          windowHeight: element.scrollHeight,
          onclone: (clonedDoc) => {
            const clonedWrappers = clonedDoc.querySelectorAll('.v-note-wrapper')
            clonedWrappers.forEach(wrapper => {
              const notePanel = wrapper.querySelector('.v-note-panel')
              const showContent = wrapper.querySelector('.v-note-show-content, .v-note-show, .v-show-content')
              if (notePanel) {
                notePanel.style.height = 'auto'
                notePanel.style.maxHeight = 'none'
              }
              if (showContent) {
                showContent.style.overflow = 'visible'
                showContent.style.height = 'auto'
                showContent.style.maxHeight = 'none'
              }
              wrapper.style.height = 'auto'
              wrapper.style.maxHeight = 'none'
            })
          }
        })

        wrappers.forEach(wrapper => {
          const notePanel = wrapper.querySelector('.v-note-panel')
          const showContent = wrapper.querySelector('.v-note-show-content, .v-note-show, .v-show-content')
          if (notePanel) {
            notePanel.style.height = ''
            notePanel.style.maxHeight = ''
          }
          if (showContent) {
            showContent.style.overflow = ''
            showContent.style.height = ''
            showContent.style.maxHeight = ''
          }
          wrapper.style.height = ''
          wrapper.style.maxHeight = ''
        })

        const filename = `replay_${new Date().toISOString().slice(0,10)}.png`
        if ('toBlob' in HTMLCanvasElement.prototype) {
          canvas.toBlob((blob) => {
            if (!blob) {
              const a = document.createElement('a')
              a.download = filename
              a.href = canvas.toDataURL('image/png')
              document.body.appendChild(a)
              a.click()
              document.body.removeChild(a)
              return
            }
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.download = filename
            a.href = url
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(url)
            document.body.removeChild(a)
          }, 'image/png')
        } else {
          const a = document.createElement('a')
          a.download = filename
          a.href = canvas.toDataURL('image/png')
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败')
      }
    },
    getScoreColor(score) {
      if (score === undefined || score === null) return '#606266'
      const percentage = (score / 100) * 100
      if (percentage >= 100) return '#237804' // 绿色
      if (percentage >= 75) return '#52C41A'  // 黄绿色
      if (percentage >= 50) return '#F7BA2A'  // 黄色
      if (percentage >= 25) return '#E6A23C'  // 橙色
      return '#F56C6C'                        // 红色
    },
    getTagColorClass(tagCode) {
      // 将tag_code转换为数字并取模，确保有颜色
      if (!tagCode) return 'tag-color-1';
      
      const colors = [
        'tag-color-1', 'tag-color-2', 'tag-color-3', 'tag-color-4', 'tag-color-5',
        'tag-color-6', 'tag-color-7', 'tag-color-8', 'tag-color-9', 'tag-color-10'
      ];
      
      // 根据tagCode的最后一位数字选择颜色
      const lastChar = tagCode.slice(-1);
      const index = parseInt(lastChar, 10) % colors.length;
      return colors[index] || colors[0];
    },
    // 使用统一的题目难度样式
    getQuestionLevelStyle,
    getErrorName(errorCode) {
      const error = this.allErrors.find(err => err.error_code === errorCode);
      return error ? error.error_name : errorCode;
    }
  }
}
</script>

<style lang="scss" scoped>
// 自定义弹窗样式
.dialog-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  
  .dialog-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .custom-dialog {
    position: absolute;
    left: 5%;
    width: 90%;
    max-height: 85vh;
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: 0 3px 15px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    
    .dialog-close {
      position: absolute;
      top: 8px;
      right: 12px;
      font-size: 24px;
      color: #909399;
      cursor: pointer;
      z-index: 10;
    }
    
    .dialog-body {
      max-height: 85vh;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */
      
      &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
      }
      
      .dialog-content {
        padding: 12px;
        
        .dialog-custom-title {
          font-size: 17px; /* 调小标题字体 */
          font-weight: 600;
          color: #303133;
          margin-top: 0;
          margin-bottom: 12px;
          padding-bottom: 8px;
          border-bottom: 1px solid #ebeef5;
          text-align: center;
          .download-btn {
            margin-left: 8px;
            color: #409EFF;
            padding: 0;
            vertical-align: middle;
          }
        }
      }
    }
  }
}

/* 添加全局样式，减少mavon-editor内部空白 */
:global(.v-note-wrapper .v-note-panel .v-note-show .v-show-content) {
  padding: 0 !important;
  min-height: 0 !important;
  height: auto !important;
  background-color: transparent !important;
  font-size: 13px !important; /* 调小markdown内容字体 */
}

:global(.v-note-wrapper .v-note-panel .v-note-show .v-show-content .markdown-body) {
  padding: 0 !important;
  margin: 0 !important;
  background-color: transparent !important;
  font-size: 13px !important; /* 调小markdown内容字体 */
}

:global(.v-note-wrapper .v-note-panel .v-note-show .v-show-content .markdown-body p) {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  line-height: 1.5 !important;
  font-size: 13px !important; /* 调小markdown内容字体 */
}

:global(.v-note-wrapper .v-note-panel .v-note-show .v-show-content .markdown-body h1) {
  font-size: 16px !important; /* 调小markdown标题字体 */
}

:global(.v-note-wrapper .v-note-panel .v-note-show .v-show-content .markdown-body h2) {
  font-size: 15px !important; /* 调小markdown标题字体 */
}

:global(.v-note-wrapper .v-note-panel .v-note-show .v-show-content .markdown-body h3) {
  font-size: 14px !important; /* 调小markdown标题字体 */
}

:global(.v-note-wrapper .v-note-panel .v-note-show .v-show-content .markdown-body h4,
       .v-note-wrapper .v-note-panel .v-note-show .v-show-content .markdown-body h5,
       .v-note-wrapper .v-note-panel .v-note-show .v-show-content .markdown-body h6) {
  font-size: 13px !important; /* 调小markdown标题字体 */
}

:global(.v-note-wrapper .v-note-panel .v-note-show .v-show-content .markdown-body code) {
  font-size: 12px !important; /* 调小代码字体 */
}

:global(.v-note-wrapper .v-note-panel .v-note-show .v-show-content .markdown-body pre) {
  font-size: 12px !important; /* 调小代码块字体 */
}

:global(.v-note-wrapper) {
  min-height: 0 !important;
  border: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
}

:global(.v-note-wrapper .v-note-panel) {
  border: none !important;
  min-height: 0 !important;
  background-color: transparent !important;
}

:global(.v-note-wrapper .v-note-panel .v-note-show) {
  border: none !important;
  min-height: 0 !important;
  background-color: transparent !important;
}

.replay-view {
  .header-section {
    background-color: #f8f9fa;
    padding: 8px 10px;
    border-radius: 8px;
    margin-bottom: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    position: relative; // 为印章定位
    
    // 移动端印章样式
    .mobile-replay-stamp {
      position: absolute;
      top: 40px;
      right: 105px;
      pointer-events: none;
      z-index: 2;
      
      .stamp-content {
        color: rgba(134, 195, 166, 0.9); // 绿色字体 - 订正
        font-size: 55px;
        font-weight: bold;
        transform: rotate(-30deg);
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80px;
        height: 80px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        
        // 创建双层弧形边框效果
        &:before, &:after {
          content: '';
          position: absolute;
          border-radius: 50%;
        }
        
        &:before {
          top: -2px;
          left: -2px;
          right: -2px;
          bottom: -2px;
          border: 2px solid rgba(134, 195, 166, 0.9);
          opacity: 0.8;
        }
        
        &:after {
          top: -6px;
          left: -6px;
          right: -6px;
          bottom: -6px;
          border: 1px dashed rgba(134, 195, 166, 0.9);
          opacity: 0.7;
        }
        
        // AK印章的样式
        &.ak-stamp {
          color: rgba(239, 198, 17, 0.95); // 金黄色字体
          
          &:before {
            border: 2px solid rgba(239, 198, 17, 0.95);
            opacity: 0.9;
          }
          
          &:after {
            border: 1px dashed rgba(239, 198, 17, 0.95);
            opacity: 0.8;
          }
        }
      }
    }
    
    .game-info {
      margin-bottom: 8px;
      
      .game-name {
        font-size: 15px; /* 调小赛事名称字体 */
        font-weight: 600;
        color: #303133;
        margin-bottom: 6px;
      }
      
      .game-tags {
        display: flex;
        gap: 6px;
        
        .game-tag {
          background-color: #ecf5ff;
          color: #409EFF;
          padding: 2px 8px;
          border-radius: 4px;
          font-size: 11px; /* 调小标签字体 */
        }
      }
    }
    
    .score-rank-info {
      display: flex;
      justify-content: space-between;
      font-size: 13px; /* 调小分数和排名字体 */
      
      .info-item {
        display: flex;
        align-items: baseline;
        
        .label {
          color: #606266;
          margin-right: 4px;
        }
        
        .highlight {
          color: #409EFF;
          font-size: 20px; /* 调小高亮数字字体 */
          font-weight: 600;
          margin: 0 2px;
        }
        
        .suffix {
          color: #909399;
        }
      }
    }
  }
  
  .section-title {
    display: flex;
    align-items: center;
    font-size: 14px; /* 调小标题字体 */
    font-weight: 600;
    color: #303133;
    margin-bottom: 4px;
    border-left: 3px solid #409EFF;
    padding-left: 8px;
    
    i {
      margin-right: 6px;
      color: #409EFF;
    }
  }
  
  .global-replay {
    margin-bottom: 10px; /* 进一步减少底部间距 */
    
    .section-title {
      margin-bottom: 4px; /* 进一步减少标题和内容的间距 */
    }
    
    .replay-content {
      background-color: transparent; /* 移除背景色 */
      border-radius: 0; /* 移除圆角 */
      overflow: visible; /* 允许内容溢出 */
      min-height: 0; /* 最小高度设为0 */
      padding: 0; /* 移除内边距 */
      border: none; /* 移除边框 */
    }
  }
  
  .questions-list {
    .section-title {
      margin-bottom: 4px; /* 进一步减少标题和内容的间距 */
    }
  }
  
  .question-items {
    .question-card {
      background-color: #f8f9fa;
      border-radius: 8px;
      margin-bottom: 8px; /* 进一步减少卡片间距 */
      padding: 6px 8px; /* 减少内边距 */
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
      
      .question-header {
        display: flex;
        align-items: center;
        margin-bottom: 4px;
        
        .question-seq {
          background-color: #409EFF;
          color: white;
          padding: 2px 6px;
          border-radius: 4px;
          font-size: 11px; /* 调小题号字体 */
          margin-right: 8px;
        }
        
        .question-name {
          font-weight: 500;
          flex: 1;
          font-size: 13px; /* 调小题目名称字体 */
        }
        
        /* 题目难度样式由引入的函数提供 */
        
        .question-scores {
          font-size: 13px; /* 调小分数字体 */
          font-weight: 600;
          white-space: nowrap;
          
          .score-label {
            color: #606266;
            margin-right: 4px;
            font-weight: normal;
          }
          
          .separator {
            margin: 0 2px;
            color: #909399;
          }
        }
      }
      
      .question-status {
        margin-bottom: 4px;
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        
        .status-tag {
          height: 20px;
          line-height: 20px;
          padding: 0 8px;
          font-size: 11px;
          border-radius: 4px;
          display: inline-flex;
          align-items: center;
          background-color: #f0f9eb;
          color: #67C23A;
          
          i {
            margin-right: 4px;
            font-size: 11px;
          }
          
          &.warning {
            background-color: #fdf6ec;
            color: #E6A23C;
          }
          
          &.danger {
            background-color: #fde2e2;
            color: #F56C6C;
          }
          
          .plan-name {
            background-color: rgba(230, 162, 60, 0.2);
            padding: 0 4px;
            margin-left: 4px;
            border-radius: 2px;
            font-size: 10px;
          }
        }
      }
      
      .question-errors {
        margin-bottom: 4px;
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        
        .question-error-tag {
          height: 20px;
          line-height: 20px;
          padding: 0 8px;
          font-size: 11px;
          border-radius: 4px;
        }
      }
      
      .question-tags {
        margin-bottom: 4px;
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        
        .question-tag {
          height: 20px;
          line-height: 20px;
          padding: 0 8px;
          font-size: 11px;
          border-radius: 4px;
        }
        
        /* 标签颜色 */
        .tag-color-1 {
          background-color: #409EFF;
          color: white;
          border-color: #409EFF;
        }
        
        .tag-color-2 {
          background-color: #67C23A;
          color: white;
          border-color: #67C23A;
        }
        
        .tag-color-3 {
          background-color: #E6A23C;
          color: white;
          border-color: #E6A23C;
        }
        
        .tag-color-4 {
          background-color: #F56C6C;
          color: white;
          border-color: #F56C6C;
        }
        
        .tag-color-5 {
          background-color: #909399;
          color: white;
          border-color: #909399;
        }
        
        .tag-color-6 {
          background-color: #9C27B0;
          color: white;
          border-color: #9C27B0;
        }
        
        .tag-color-7 {
          background-color: #FF9800;
          color: white;
          border-color: #FF9800;
        }
        
        .tag-color-8 {
          background-color: #795548;
          color: white;
          border-color: #795548;
        }
        
        .tag-color-9 {
          background-color: #607D8B;
          color: white;
          border-color: #607D8B;
        }
        
        .tag-color-10 {
          background-color: #2196F3;
          color: white;
          border-color: #2196F3;
        }
      }
      
      
      .replay-content {
        margin-top: 4px; /* 减少上边距 */
        min-height: 0; /* 最小高度设为0 */
        padding: 0; /* 移除内边距 */
        border: none; /* 移除边框 */
        background-color: transparent; /* 移除背景色 */
      }
    }
  }
  
  .empty-content {
    text-align: center;
    color: #909399;
    padding: 20px 0; /* 减少内边距 */
    font-size: 14px;
  }
  
  :deep(.md-editor) {
    border: none;
    margin: 0;
    padding: 0;
    
    .v-note-wrapper {
      min-height: auto !important;
      z-index: 1;
      box-shadow: none !important;
      border: none !important;
      margin: 0 !important;
      padding: 0 !important;
      
      .v-note-op {
        display: none !important; /* 隐藏顶部工具栏 */
      }
      
      .v-note-edit {
        display: none !important; /* 隐藏编辑区域 */
      }
    }
    
    .v-note-panel {
      border: none;
      position: relative !important;
      display: block !important;
      width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      
      .v-note-show {
        position: relative !important;
        width: 100% !important;
        height: auto !important;
        flex: none !important;
        border: none !important;
        margin: 0 !important;
        padding: 0 !important;
      }
    }
    
    .v-show-content {
      min-height: 10px !important; /* 减少最小高度 */
      padding: 5px 8px !important; /* 减少内边距 */
      background-color: #f8f9fa;
      height: auto !important;
      border: none !important;
      margin: 0 !important;
      
      /* 移除可能导致多余空间的样式 */
      &:after, &:before {
        display: none !important;
      }
      
      /* 确保内容区域没有不必要的边距和填充 */
      p {
        margin-top: 0;
        margin-bottom: 4px; /* 减少段落间距 */
        
        &:last-child {
          margin-bottom: 0;
        }
      }
      
      /* 处理红色边框问题 */
      .github-markdown-body {
        border: none !important;
        margin: 0 !important;
        padding: 0 !important;
      }
    }
  }
}

/* 添加紧凑型编辑器样式 */
.compact-editor {
  :deep(.v-note-wrapper) {
    min-height: 0 !important;
    
    .v-note-panel {
      min-height: 0 !important;
    }
    
    .v-note-show {
      min-height: 0 !important;
      
      .v-show-content {
        min-height: 0 !important;
        padding: 0 !important;
      }
    }
  }
}

/* 隐藏所有滚动条 */
:global(*::-webkit-scrollbar) {
  display: none !important;
}

:global(*) {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}
</style>
